export enum CardType {
  spdr = "Spdr",
  pdsr = "Pdsr",
  dragCard = "dragCard",
}
